// extracted by mini-css-extract-plugin
module.exports =  {"table":"table-QbfK0","week":"week-mTZNI","day":"day-LPW9e","long":"long-UpX3r","short":"short-MoF9_","grid":"grid-cUaUg"};